import { useEffect } from 'react'
import { Outlet } from 'react-router'
import { useKeysStore } from '@/stores/keys'

export function RootLayout() {
  const init = useKeysStore((s) => s.init)

  useEffect(() => {
    void init()
  }, [init])

  return (
    <div className="min-h-screen bg-[#09090b] text-[#f4f4f5] font-sans">
      <Outlet />
    </div>
  )
}
